import { getTranslation } from 'utils/getTranslation';
import * as yup from 'yup';

import { petSchema, PetSchemaType } from './petSchema';
import { userSchema, UserSchemaType } from './userSchema';

export type RegisterPetSchemaType = {
  user: UserSchemaType;
  pets: PetSchemaType[];
  privacyPolicyAgreement?: boolean;
};

const t = getTranslation('donor.ValidationErrors');

export const registerPetSchema = yup.object().shape({
  user: userSchema,
  pets: yup
    .array()
    .of(petSchema)
    .min(1, t('atLeastOnePet'))
    .max(5, t('maximumPetsRegistred'))
    .required(),
  privacyPolicyAgreement: yup.boolean(),
}) as yup.SchemaOf<RegisterPetSchemaType>;
